import { useState } from 'react';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import useAssignmentsByCenter from '@nkr/store/microsites/hooks/use-assignments-by-center';
import { styles } from './styles';

interface IProps {
    isSuperAdmin: boolean;
    year: number;
    coachId: number;
}

const AssignmentsByCenterModal = ({ isSuperAdmin, year, coachId }: IProps) => {
    const [show, setShow] = useState<boolean>(false);
    const { data, columns, loading, error, exportData } = useAssignmentsByCenter(isSuperAdmin, year, coachId, show);

    return (
        <>
            <Button bsStyle='primary' bsSize='xsmall' style={styles.drillButton} onClick={() => setShow(true)}>R</Button>

            <Modal show={show} onHide={() => setShow(false)} bsSize='large'>
                <Modal.Header closeButton><Modal.Title>New Assignments by Center</Modal.Title></Modal.Header>
                <Modal.Body>
                    {loading && <Alert bsStyle='info'>Loading...</Alert>}
                    {!loading && error && <Alert bsStyle='danger'>{error}</Alert>}
                    {!loading && !error && data && (
                        <div style={styles.gridWrapper}>
                            <Table striped condensed bordered>
                                <thead>
                                    <tr>
                                        <th style={{...styles.compactHeaderCell, ...styles.centerListHeader}}>Center</th>
                                        {columns.map(col => (
                                            <th key={col.key} style={{...styles.compactHeaderCell, ...styles.centerListHeader}}>
                                                {col.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(center => (
                                        <tr key={center.centerAlias}>
                                            <td style={styles.compactCell}>{center.centerAlias}</td>
                                            {columns.map(col => (
                                                <td key={col.key} style={styles.compactCell}>{center.months[col.key] ?? 0}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => exportData()} disabled={!data}>Export</Button>
                    <Button onClick={() => setShow(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AssignmentsByCenterModal;
